import styles from "./AccessLevel.module.css";
import PropTypes from "prop-types";
import classNames from "classnames";

/**
 *
 * Displays the diamonds access level. The different access levels are EC, MT1, MT2, RO, and None.
 *
 */

export function AccessLevel({ accessLevel, textColor="#000000" }) {
  return (
    <button
      className={classNames(
        styles.container,
        accessLevel == "MT1" && styles.MT1,
        accessLevel == "MT2" && styles.MT2,
        accessLevel == "GUEST" && styles.RO,
        accessLevel == "MANAGER" && styles.MANAGER
      )}
    >
      <span style={{color: textColor}}>{accessLevel}</span>
    </button>
  );
}

AccessLevel.propTypes = {
  accessLevel: PropTypes.string,
};
